import { cloneDeep, merge } from 'es-toolkit/compat';

import { RecursivePartial } from 'app/types';

import { colorPalette, primitiveColors, semanticColors } from './colors';
import { Theme } from '.';
import { breakPoints } from '../constants/styles';

export const createTheme = (themeOverrides: RecursivePartial<Theme>): Theme => {
  const baseTheme: Theme = cloneDeep<Theme>({
    colors: colorPalette,
    components: {
      button: {
        borderRadius: 8,
        size: {
          lg: 40,
          md: 32,
          sm: 24,
        },
      },
      form: {
        fieldGapX: 4,
        fieldGapY: 6,
      },
      global: {
        brandBoxShadow: '0 0 18px 0 rgba(1, 115, 157, 0.35)',
        hoverBoxShadow: '0 0 12px 0 rgba(0, 0, 0, 0.23)',
      },
      mediaQueries: {
        lg: {
          max: `@media only screen and (max-width: ${breakPoints.desktop + 160}px)`,
          min: `@media only screen and (min-width: ${breakPoints.desktop + 1}px)`,
        },
        md: {
          max: `@media only screen and (max-width: ${breakPoints.desktop}px)`,
          min: `@media only screen and (min-width: ${breakPoints.tablet + 1}px)`,
        },
        sm: {
          max: `@media only screen and (max-width: ${breakPoints.tablet}px)`,
          min: `@media only screen and (min-width: ${breakPoints.mobile + 1}px)`,
        },
        xs: {
          max: `@media only screen and (max-width: ${breakPoints.mobile}px)`,
        },
      },
    },
    mode: 'light',
    primitiveColors,
    semanticColors,
    sizes: {
      fontSizes: {
        body: 16,
        heading1: 40,
        heading2: 32,
        heading3: 24,
        heading4: 16,
        legal: 12,
        smallBody: 14,
      },
    },
    spacing: 4,
  });

  return merge(baseTheme,
    themeOverrides);
};
